import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/build/style.css';
import 'material-icons';
import 'jodit/build/jodit.min.css';
import * as bootstrap from 'uiv';
import { sync } from 'vuex-router-sync';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(bootstrap, { prefix: 'b' });
Vue.use(Vuelidate);
Vue.config.productionTip = false;

const siteUrl = process.env.VUE_APP_SERVER_URL;
const axiosInstance = axios.create({ baseURL: siteUrl, responseType: 'json' });

sync(store, router);

Vue.prototype.$axios = axiosInstance;

new Vue({
	store,
	router,
	async beforeCreate() {
		await this.$store.dispatch('login');
	},
	validations: {},
	render: h => h(App),
}).$mount('#app');
